import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import qs from 'qs';
import { withRouter } from 'react-router-dom';
import { Row, Col } from '@saucelabs/sl-component-grid';
import { FormAlert } from '@saucelabs/sl-component-form';
import { apiBaseUrls, MULTI_DC_SUPPORT, DEFAULT_DC } from '@saucelabs/sl-util-config';
import { operations as authOperations } from '@saucelabs/sl-container-authentication';

import { operations } from './../ducks/container';
import FormTitle from './../components/FormTitle';
import HelpLinks from './../components/HelpLinks';
import LoginForm from './../components/LoginForm';
import FormWrapper from './../components/FormWrapper';

class LoginContainer extends Component {
  componentDidMount() {
    window.addEventListener('beforeunload', authOperations.resetInfoAboutInactivityLogout);
  }

  componentWillUnmount() {
    authOperations.resetInfoAboutInactivityLogout();
    window.removeEventListener('beforeunload', authOperations.resetInfoAboutInactivityLogout);
  }

  render() {
    const {
      errorMessage,
      infoMessage,
      loginUser,
      nextQueryParam,
      successMessage,
      warningMessage,
    } = this.props;

    return (
      <Row between="xs">
        <Col xs={12}>
          <FormWrapper>
            <Helmet>
              <title>Login</title>
            </Helmet>
            <FormTitle>Sign In</FormTitle>
            <FormAlert type="success">{successMessage}</FormAlert>
            <FormAlert type="danger">{errorMessage}</FormAlert>
            <FormAlert type="warning">{warningMessage}</FormAlert>
            <FormAlert type="info">{infoMessage}</FormAlert>
            <LoginForm
              loginUser={loginUser}
              nextQueryParam={nextQueryParam}
            />
            <HelpLinks>
              <div>
                {'New to Sauce Labs? '}
                <a href={apiBaseUrls.signup}>
                  Create an Account
                </a>
              </div>
              <div>
                {`Login with GitHub is currently supported only in '${DEFAULT_DC}' DC`}
              </div>
              <br />
              <div>
                <strong>Real Device Cloud (formerly TestObject)</strong>
                <br />
                {'Looking for the Real Device Cloud? '}
                <a
                  href="https://app.testobject.com/#/login/"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Log in here
                </a>
              </div>
            </HelpLinks>
          </FormWrapper>
        </Col>
      </Row>
    );
  }
}


const mapStateToProps = (store, { location: { search, state } }) => {
  const queryParams = qs.parse(search, { ignoreQueryPrefix: true });
  const multiDCLoginWarning = 'Please note that to use Headless and Virtual Cloud at the same time, you will need to use two separate browsers';
  const inactivityLogoutInfo = 'You have been logged out due to inactivity';

  return {
    nextQueryParam: queryParams.next || queryParams.redirect_to || '/dashboard/tests/vdc',
    successMessage: state?.success,
    errorMessage: state?.error,
    warningMessage: (state?.warning) ||
     (MULTI_DC_SUPPORT && !state ? multiDCLoginWarning : null),
    infoMessage: authOperations.showInfoAboutInactivityLogout() ? inactivityLogoutInfo : null,
  };
};

const mapDispatchToProps = {
  loginUser: operations.login,
};

LoginContainer.propTypes = {
  errorMessage: PropTypes.string,
  infoMessage: PropTypes.string,
  loginUser: PropTypes.func.isRequired,
  nextQueryParam: PropTypes.string,
  successMessage: PropTypes.string,
  warningMessage: PropTypes.string,
};

LoginContainer.defaultProps = {
  errorMessage: null,
  infoMessage: null,
  nextQueryParam: null,
  successMessage: null,
  warningMessage: null,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginContainer));
export { LoginContainer, mapDispatchToProps };
